import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import IMG_1 from "assets/images/scooter/viva/img-hardware-1.png";
import IMG_2 from "assets/images/scooter/viva/img-hardware-2.png";
import IMG_3 from "assets/images/scooter/viva/img-hardware-3.png";
import IMG_4 from "assets/images/scooter/viva/img-hardware-4.png";
import IMG_5 from "assets/images/scooter/viva/img-hardware-5.png";
// Import Swiper styles start
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// Import Swiper styles end

/**
 * @file 스마트스쿠터-VIVA 화면에서의 swiper
 */
function ScooterTestSwiper() {
  var describesOne = [
    { url: IMG_1, title: "21.6L 대용량 수납공간" },
    { url: IMG_2, title: "스마트 배터리" },
    { url: IMG_3, title: "SBS 싱크로나이즈드\n브레이크 시스템*" },
    { url: IMG_4, title: "풀 LED 조명 시스템" },
    { url: IMG_5, title: "내구성 높은 기술" },
  ];
  const settings = {
    className: "swiper-describe-one swiper-box",
    direction: "horizontal",
    modules: [Navigation],
    navigation: {
      nextEl: ".slide-control-btn.next",
      prevEl: ".slide-control-btn.prev",
    },
    slidesPerView: "auto",
    spaceBetween: 32,
    loop: false,
    centeredSlides: true,
    breakpoints: {
      100: {
        centeredSlides: false,
        spaceBetween: 32,
      },
      768: {
        centeredSlides: false,
        spaceBetween: 32,
      },
      1180: {
        centeredSlides: true,
        spaceBetween: 34,
      },
    },
  };

  return (
    <Swiper {...settings}>
      <div className="swiper-wrapper">
        {describesOne.map((val, i) => (
          <SwiperSlide className="swiper-slide" key={"scooter-viva-img-desc-swiper-slide-" + i}>
            <img className="img-box" src={val.url} alt="" />
            <div className="text-box">
              <div className="t1">{val.title}</div>
            </div>
          </SwiperSlide>
        ))}
      </div>
    </Swiper>
  );
}

export default ScooterTestSwiper;
